/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadmitToFacility200ResponseData
 */
export interface ReadmitToFacility200ResponseData {
    /**
     * 
     */
    success?: boolean;
}

/**
 * Check if a given object implements the ReadmitToFacility200ResponseData interface.
 */
export function instanceOfReadmitToFacility200ResponseData(value: object): value is ReadmitToFacility200ResponseData {
    return true;
}

export function ReadmitToFacility200ResponseDataFromJSON(json: any): ReadmitToFacility200ResponseData {
    return ReadmitToFacility200ResponseDataFromJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacility200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function ReadmitToFacility200ResponseDataToJSON(json: any): ReadmitToFacility200ResponseData {
    return ReadmitToFacility200ResponseDataToJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseDataToJSONTyped(value?: ReadmitToFacility200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

